import { datadogRum } from "@datadog/browser-rum";

export function initDatadog() {
  try {
    datadogRum.init({
      applicationId: process.env.VUE_APP_DATADOG_APPID,
      clientToken: process.env.VUE_APP_DATADOG_TOKEN,
      site: "datadoghq.eu",
      service: "yoh-registration-form",
      env: process.env.VUE_APP_DATADOG_ENV,
      sessionSampleRate: 100,
      sessionReplaySampleRate: 100,
      trackUserInteractions: true,
      trackResources: true,
      trackLongTasks: true,
      defaultPrivacyLevel: "mask-user-input",
    });
    datadogRum.startSessionReplayRecording();
  } catch (ex) {
    console.log(ex);
  }
}

export function setDatadogUser(contactId, email) {
  try {
    datadogRum.setUser({
      id: contactId,
      email: email,
    });
  } catch (ex) {
    console.log(ex);
  }
}

export function trackFunnelStarted() {
  try {
    datadogRum.addAction("registration_funnel_started");
    datadogRum.setGlobalContextProperty("registration_step", 0);
  } catch (ex) {
    console.log(ex);
  }
}

const STEP_ACTION_NAMES = {
  0: "registration_step_webinar_selection_completed",
  1: "registration_step_personal_details_completed",
  3: "registration_step_smart_registration_completed",
};

export function trackStepCompleted(stepIndex, stepName) {
  try {
    const actionName = STEP_ACTION_NAMES[stepIndex] ?? "registration_step_completed";
    datadogRum.addAction(actionName, {
      step_index: stepIndex,
      step_name: stepName,
    });
    datadogRum.setGlobalContextProperty("registration_step", stepIndex + 1);
  } catch (ex) {
    console.log(ex);
  }
}

export function trackStepBack(stepIndex, stepName) {
  try {
    datadogRum.addAction("registration_step_back", {
      step_index: stepIndex,
      step_name: stepName,
    });
  } catch (ex) {
    console.log(ex);
  }
}

export function trackValidationFailed(stepIndex, stepName) {
  try {
    datadogRum.addAction("registration_step_validation_failed", {
      step_index: stepIndex,
      step_name: stepName,
    });
  } catch (ex) {
    console.log(ex);
  }
}

export function trackYohRegistrationCompleted() {
  try {
    datadogRum.addAction("registration_yoh_completed");
  } catch (ex) {
    console.log(ex);
  }
}

export function trackExistingClientCompleted() {
  try {
    datadogRum.addAction("registration_existing_smart_client_completed");
  } catch (ex) {
    console.log(ex);
  }
}

export function trackRegistrationCompleted() {
  try {
    datadogRum.addAction("smart_registration_completed");
  } catch (ex) {
    console.log(ex);
  }
}

export function trackWebinarSelectionError(errorType, errorMessage, details = {}) {
  try {
    datadogRum.addError(new Error(`WebinarSelection Error: ${errorType}`), {
      error_type: errorType,
      error_message: errorMessage,
      step: "webinar_selection",
      ...details,
    });
  } catch (ex) {
    console.log(ex);
  }
}
